export default function adaptToResponsive(options) {
  options.xAxis = {
    ...options.xAxis,
    show: false,
  };

  options.tooltip = {
    confine: true,
  };

  return options;
}
